//BFSG checked
import styled from 'styled-components'
import React from 'react'
import { ReactComponent as CloseIcon } from 'assets/menu-close.svg'
import { theme } from 'containers/GlobalStyle'
import { ReactComponent as CheckIcon } from 'assets/green-check-round.svg'
import useTranslations from 'hooks/useTranslations'
import withTranslation from './withTranslation'

type Props = {
  onClose: () => void
}

function DeliveryByPartnerModal(props: Props) {
  const t = useTranslations<'molecules-delivery-by-partner-modal'>()

  const prevFocusEl = React.useRef<HTMLElement | null>(null)
  const closeBtnRef = React.useRef<HTMLButtonElement>(null)
  document.body.classList.add('scrolllock')
  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      e.preventDefault()
      handleClose(e)
    }
  }
  const handleClose = (e) => {
    prevFocusEl.current?.focus()

    props.onClose()
    prevFocusEl.current?.focus()
  }

  React.useEffect(() => {
    document.body.style.overflow = 'hidden'
    prevFocusEl.current = document.activeElement as HTMLElement
    closeBtnRef.current?.focus()
    document.addEventListener('keydown', handleKeyDown)
    return () => {
      document.body.style.overflow = 'hidden overlay'
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [])

  return (
    <Wrapper
      className="DeliveryByPartnerModal"
      data-cy-ctx="molecules/DeliveryByPartnerModal"
      onClick={handleClose}
    >
      <div className="modal-container">
        <button
          className="modal-close-icon"
          onClick={handleClose}
          data-cy-handle="close-delivery-partner-modal"
          ref={closeBtnRef}
          tabIndex={0}
          aria-label="Close" // TODO: bfsg snippet modal-close
        >
          <CloseIcon />
        </button>
        <div className="modal-content">
          <div className="modal-header">{t('partner_products_headline')}</div>
          <div className="modal-subheader">{t('subheadline')}</div>
          <div className="modal-text">{t('description')}</div>
          <div className="modal-subheader">{t('conditions_headline')}</div>
          <ul className="modal-benefits">
            <li className="benefit">
              <CheckIcon />
              <div className="benefit-text">{t('condition_1')}</div>
            </li>
            <li className="benefit">
              <CheckIcon />
              <div className="benefit-text">{t('condition_2')}</div>
            </li>
            <li className="benefit">
              <CheckIcon />
              <div className="benefit-text">{t('condition_3')}</div>
            </li>
            <li className="benefit">
              <CheckIcon />
              <div className="benefit-text">{t('condition_4')}</div>
            </li>
            <li className="benefit">
              <CheckIcon />
              <div className="benefit-text">{t('condition_5')}</div>
            </li>
          </ul>
          <div className="logo-box">
            <div className="logo-text">{t('company_label')}</div>
          </div>
        </div>
      </div>
    </Wrapper>
  )
}

export default withTranslation(DeliveryByPartnerModal)

const Wrapper = styled.div`
  top: 0;
  left: 0;
  position: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: ${theme.zIndex
    .theme_molecules_deliverybypartnermodal_deliveryByPartnerModal};

  > .modal-container {
    background-color: white;
    padding-left: ${theme.spacing('ml')};
    padding-right: ${theme.spacing('ml')};
    padding-top: 1.375rem;
    max-width: 46.875rem;
    min-height: 25rem;
    opacity: 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;

    > .modal-close-icon {
      display: flex;
      justify-content: flex-end;
      place-self: flex-end;
      margin-right: ${theme.spacing('xs')};
      height: 1.25rem;
      width: 1.25rem;

      > svg {
        cursor: pointer;
        height: 1.125rem;
        width: 1.125rem;
        font-size: 2rem;
      }
    }

    > .modal-content {
      display: flex;
      flex-direction: column;
      margin-bottom: ${theme.spacing('s')};

      > .modal-header {
        ${theme.ty('r-l', 'bold', 'r-2xl')}
        padding-bottom: ${theme.spacing('m')};
        max-width: 50%;
        user-select: none;
      }

      > .modal-subheader {
        ${theme.ty('rc-base', 'bold', 'rc-l')}
        padding-bottom: ${theme.spacing('m')};
      }

      > .modal-text {
        ${theme.ty('rc-base', null, 'r-base')}
        padding-bottom: ${theme.spacing('m')};
      }

      > .modal-benefits {
        display: flex;
        flex-direction: column;
        gap: ${theme.spacing('s')};
        > .benefit {
          display: flex;
          flex-direction: row;
          gap: ${theme.spacing('xs')};

          > svg {
            min-height: 1.25rem;
            min-width: 1.25rem;
          }
          > .benefit-text {
            ${theme.ty('rc-base', null, 'r-base')}
          }
        }
      }

      > .logo-box {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: ${theme.spacing('m')};
        background-color: ${theme.colors.primary};

        margin: ${theme.spacing('m')} 0;
        > .logo-text {
          ${theme.ty('rc-base', 'bold', 'rc-2xl')}
          text-align: center;
        }
      }
    }
  }
`
